import { formFieldsValidation } from '../wcl-helpers.js';
import { SendFormData } from '../wcl-helpers.js';

if (document.querySelector('.wcl-order-data-form')) {
    const form = document.querySelector('.wcl-order-data-form');

    // Get variables
    const wpnonce = form.querySelector('#wcl_order_data_form_wpnonce');
    const submitBtn = form.querySelector('.wcl-button');
    const orderID = form.dataset.orderId;

    // Get UI element
    const noticesWrapper = form.querySelector('.woocommerce-notices-wrapper');

    submitBtn.addEventListener('click', e => {
        e.preventDefault();

        const formInputs = form.querySelectorAll ('.data-input:not(.form-row-disabled)');
        
        noticesWrapper.innerHTML = '';

        // Validation
        if (formFieldsValidation(formInputs)) {
            noticesWrapper.innerHTML = `
                <div class="woocommerce-error">
                    Please fill in all fields.
                </div>
            `;
            return;
        }

        let formData = new FormData(form);

        // Add product name
        formData.append('wpnonce', wpnonce.value);
        formData.append('orderID', orderID);
        formData.append('order_product_name', form.dataset.productName);

        // Show preloader
        form.classList.add('loading');

        // AJAX to procees the order
        SendFormData('save_order_details', formData).then(function (res) {
            form.classList.remove('loading');

            let response = JSON.parse(res);

            if (response.notice_markup) {
                noticesWrapper.innerHTML = response.notice_markup;
            } else if (response.message) {
                throw new Error(response.message);
            } else {
                noticesWrapper.innerHTML = `
                    <div class="woocommerce-error">
                        Something went wrong. Please, contact us or try again later	
                    </div>
                `;
            }

        }).catch(function (err) {
            // Error
            form.classList.remove('loading');

            noticesWrapper.innerHTML = `
                <div class="woocommerce-error">
                    ${err}	
                </div>
            `;
        });
    });
}